import { Box, Typography } from "@mui/material";
import { ReactComponent as AutoInvestIcon } from "../../assets/icons/auto-invest-colored.svg";
import { ReactComponent as RecieptIcon } from "../../assets/icons/reciept-colored.svg";
import { ReactComponent as WalletLeftArrowIcon } from "../../assets/icons/wallet-left-arrow.svg";
import { ReactComponent as WallerArrowIcon } from "../../assets/icons/wallet-arrow-colored.svg";
import IconRowWithArrow from "../shared/IconRowWithArrow";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

function LinksList({ sx = [], ...props }) {
  const navigate = useNavigate();
  const { config } = useSelector((state) => state.config);
  const { walletId, loading } = props;
  const [investmentStatus, setInvestmentStatus] = useState(
    config.profile.hasAutoInvestment
  );
  const [subscriptionStatus, setSubscriptionStatus] = useState(
    config.profile.hasAutoSaving
  );

  useEffect(() => {
    setInvestmentStatus(config.profile.hasAutoInvestment);
  }, [config.profile.hasAutoInvestment]);

  useEffect(() => {
    setSubscriptionStatus(config.profile.hasAutoSaving);
  }, [config.profile.hasAutoSaving]);

  return (
    <Box
      sx={{
        bgcolor: "common.white",
        minHeight: 220,
        width: "100%",
        px: "16px",
        py: "24px",
        borderRadius: "12px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {[
        {
          title: "برداشت",
          icon: WalletLeftArrowIcon,
          action: () => {
            !loading && navigate("/app/cashout", { state: { walletId } });
          },
        },
        {
          title: "پس‌انداز خودکار",
          icon: WallerArrowIcon,
          value: subscriptionStatus ? "فعال" : "فعال کنید",
          greenBox: !subscriptionStatus,
          action: () => {
            navigate("/app/direct-debit");
          },
        },
        {
          title: "سرمایه‌گذاری خودکار",
          icon: AutoInvestIcon,
          value: investmentStatus ? "فعال" : "فعال کنید",
          greenBox: !investmentStatus,
          action: () => {
            navigate("/app/auto-investment");
          },
        },
        {
          title: "صورت حساب",
          icon: RecieptIcon,
          action: () => {
            navigate("/app/receipt");
          },
        },
      ].map((item) => {
        return (
          <IconRowWithArrow
            key={item.title}
            title={item.title}
            icon={item.icon}
            onClick={item.action}
            greenBox={item.greenBox}
            value={item.value}
          />
        );
      })}
    </Box>
  );
}

export default LinksList;
